<template>
    <div>
        <app-filepicker
            label="Bild"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.slides.' + listitemId + '.data.image'
            "
            accept=".jpg,.png,.gif"
            :show-focus="
                !['auto'].includes(getProp('tecpage.user.modules.' + moduleId + '.data.type'))
            "
            :show-transparency="true"
            :show-scaling-mode="
                !['auto'].includes(getProp('tecpage.user.modules.' + moduleId + '.data.type'))
            "
        ></app-filepicker>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Filepicker from '@/components/fields/complex/Filepicker.vue';
import { EventBus } from '@/helpers/event-bus';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['getProp', 'hasPackageBasic'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R029'),
            help: this.$helpers.uiText('R085'),
            removeText: this.$helpers.uiText('R031')
        });
        EventBus.$emit('slider-goto', {
            id: this.listitemId
        });
    },
    props: {
        moduleId: String,
        listitemId: String
    },
    components: {
        'app-filepicker': Filepicker
    }
};
</script>
